export const TableTopTypeEnum = {
    FILLED: 'FILLED',
    TRANSPARENT: 'TRANSPARENT'
};